import { computed, ref, watch, toValue } from 'vue';
import Header, { ExportOptions } from 'Components/datagrid/types/header';
export function resolveNestedValue(obj, path) {
    if (!obj || !path)
        return '';
    if (path.indexOf('.') === -1) {
        return obj[path];
    }
    return path.split('.').reduce((acc, part) => (acc ? acc[part] : undefined), obj);
}
export function useHeadersBuilder(options = {}) {
    const currentHeaders = options.currentHeaders ?? ref([]);
    if (options.headers && !options.currentHeaders) {
        watch(() => toValue(options.headers), (newHeaders) => {
            currentHeaders.value = (newHeaders || []).map((h) => (h instanceof Header ? h : new Header(h)));
        }, { immediate: true, deep: true });
    }
    const visibleHeaders = computed(() => {
        if (options.keyDependency) {
            toValue(options.keyDependency);
        }
        return currentHeaders.value.filter((h) => !h.isHidden);
    });
    const headersForList = computed(() => {
        const result = [];
        if (options.keyDependency) {
            toValue(options.keyDependency);
        }
        const showSelect = toValue(options.showSelect);
        const showSingleSelect = toValue(options.showSingleSelect);
        const showExpand = toValue(options.showExpand);
        const preserveColumnWidth = toValue(options.preserveColumnWidth);
        const showActions = toValue(options.showActions);
        const actionColumnWidth = toValue(options.actionColumnWidth) ?? '150px';
        const canBeFiltered = toValue(options.canBeFiltered);
        if (showSingleSelect) {
            result.push({
                title: '',
                value: 'data-table-single-select',
                width: '32px',
                minWidth: '32px',
                isFixed: true,
                canBeToggled: false,
                key: 'data-table-single-select'
            });
        }
        if (showSelect) {
            result.push({
                title: '',
                value: 'data-table-select',
                width: '32px',
                minWidth: '32px',
                isFixed: true,
                canBeToggled: false,
                ...(canBeFiltered !== undefined ? { canBeFiltered } : {}),
                key: 'data-table-select',
            });
        }
        if (showExpand) {
            result.push({
                title: '',
                value: 'data-table-expand',
                isFixed: true,
                canBeToggled: false,
                ...(canBeFiltered !== undefined ? { canBeFiltered } : {}),
                key: 'data-table-expand',
            });
        }
        visibleHeaders.value.forEach((h) => {
            result.push({
                ...h,
                ...(canBeFiltered !== undefined ? { canBeFiltered } : {}),
                key: h.value,
            });
        });
        if (preserveColumnWidth) {
            const col = {
                title: '',
                value: '',
                sortable: false,
                isFixed: true,
                key: 'preserve-space',
            };
            if (canBeFiltered !== undefined) {
                col.canBeFiltered = canBeFiltered;
            }
            if (options.includeExportOptions) {
                col.exportOptions = new ExportOptions({ isIgnored: true });
            }
            result.push(col);
        }
        if (showActions) {
            result.push({
                title: '',
                value: 'actions',
                minWidth: actionColumnWidth,
                isFixed: true,
                canBeToggled: false,
                ...(canBeFiltered !== undefined ? { canBeFiltered } : {}),
                key: 'actions',
            });
        }
        return result;
    });
    return {
        currentHeaders,
        visibleHeaders,
        headersForList,
    };
}
